import React, { useContext } from 'react';

import DetailsComponent from './DetailsComponent.jsx';
import Button from './Button.jsx';

import TranslationsContext from '../TranslationsContext';

export default function DetailsStep({ depositedData, setDepositedData, currentDog, subscriptionProducts, step, setStep, setWidgetError, navigate }) {
	const t = useContext(TranslationsContext);

	return (
		<>
			<DetailsComponent
				setDepositedData={setDepositedData}
				depositedData={depositedData}
				currentDog={currentDog}
				subscriptionProducts={subscriptionProducts}
				step={step}
				setStep={setStep}
				setWidgetError={setWidgetError}
			/>
			<div className="subscriptions-configurator__buttons-wrapper column small-12 flex-container flex-dir-row align-spaced section-spacing-padding">
				<Button
					type="button"
					action={step - 1}
					setStep={(nextStep) => {
						setDepositedData((prevState) => {
							prevState[currentDog] = {
								...prevState[currentDog],
								dogWeight: 0,
								dogWeightUnit: 'lbs',
							};
							return prevState;
						});
						setWidgetError('');
						window.scrollTo({ top: 0, behavior: 'smooth' });
						navigate('/pages/subscriptions');
						setStep(nextStep);
					}}
					text={t('back')}
					classname="button button--border-green white"
				/>
				<Button
					type="button"
					action={step + 1}
					setStep={(nextStep) => {
						if (depositedData.some((el) => el.dogWeight === 0 || el.dogWeight === '')) {
							setWidgetError(t('error_enter_dog_weight'));
						} else {
							window.scrollTo({ top: 0, behavior: 'smooth' });
							setWidgetError('');
							navigate('/pages/subscriptions/configuration');
							setStep(nextStep);
						}
					}}
					text={t('next')}
					classname="button button--gradient-green"
				/>
			</div>
		</>
	);
}
